module.exports = __webpack_public_path__ + "static/media/video-bg-light.364d6351.mp4";